import React from 'react';

interface TokenIconProps {
    className?: string
}

const TokenIcon = ({ className }: TokenIconProps) => {
    return (
        <svg className={className} viewBox="0 0 133 133" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_326_24)">
                {/* eslint-disable-next-line max-len */}
                <path d="M67.5353 0.00897687C66.1918 -0.0137003 64.847 0.00663814 63.5039 0.0694161C34.1651 1.00171 6.9219 23.7407 1.41025 52.6886C-4.0754 78.0996 6.75216 106.443 28.502 120.958C48.6673 135.037 76.8916 136.938 98.3556 124.622C119.769 112.863 133.989 88.7175 132.775 64.169C132.011 39.9167 117.053 16.4369 94.791 6.42292C86.2954 2.39008 76.9394 0.165487 67.5353 0.00897687ZM66.379 5.99142C79.8692 5.92301 93.2847 10.6924 103.863 19.0402C122.025 32.9773 130.618 57.8879 125.201 80.0929C120.216 102.785 100.893 121.396 78.0861 125.687C56.649 130.165 33.2782 121.6 19.5586 104.597C5.33044 87.4862 2.01768 62.3114 11.1075 42.0363C19.9919 21.3873 41.2544 6.9433 63.6817 6.06951C64.5809 6.02151 65.4796 5.99596 66.379 5.99142Z" fill="#FFCC00" />
                {/* eslint-disable-next-line max-len */}
                <path d="M66.3759 120.88C96.4463 120.88 120.823 96.5034 120.823 66.433C120.823 36.3627 96.4463 11.9858 66.3759 11.9858C36.3055 11.9858 11.9287 36.3627 11.9287 66.433C11.9287 96.5034 36.3055 120.88 66.3759 120.88Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_326_24">
                    <rect width="132.848" height="132.798" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default TokenIcon;
